import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SectionHero } from '../components/sections/SectionHero';
import { SEO } from '../components/SEO';
import { PAGE_SEO } from '../config/seoCopy';
import { motion } from 'framer-motion';
import { Download, Phone, Mail, ExternalLink, Crown, Star, Award, Users, Check, ArrowRight } from 'lucide-react';
import { trackWhatsAppLead } from '../lib/trackLead';

const FesTeAbonatPage = () => {
  const { language } = useLanguage();

  const translations = {
    ca: {
      title: "Fes-te Abonat",
      subtitle: "Uneix-te a la família UGOLF ARAVELL",
      intro: "Descobreix els avantatges exclusius de ser abonat al camp de golf més espectacular dels Pirineus. Tres modalitats adaptades a les teves necessitats.",
      membersAccess: "Ja ets abonat?",
      membersBtn: "Accés Àrea Membres",
      quotesTitle: "Modalitats d'Abonament 2026",
      downloadQuotes: "Descarregar quotes completes (PDF)",
      downloadContract: "Descarregar sol·licitud d'alta",
      downloadContractEs: "Descargar solicitud de alta (ES)",
      contact: "Contacte",
      contactDesc: "Per més informació sobre els abonaments",
      whatsapp: "WhatsApp",
      email: "Enviar email",
      entryFee: "Quota d'entrada",
      annual: "Quota anual",
      perRound: "per volta",
      included: "Inclòs",
      moreInfo: "Més informació",
      oro: {
        name: "ORO",
        price: "2.040€",
        entry: "300€",
        perRound: "5€ / 3€",
        perRoundLabel: "Greenfee 18/9 forats",
        features: [
          "Targeta Le Club Gold inclosa",
          "70% descompte competicions",
          "Assegurança de quota",
          "Invitació mensual gratuïta (si pagament anual)",
          "Programa fidelització"
        ]
      },
      plata: {
        name: "PLATA",
        price: "1.400€",
        entry: "300€",
        perRound: "15€ / 12€",
        perRoundLabel: "Greenfee 18/9 forats",
        features: [
          "Targeta Le Club Gold inclosa",
          "50% descompte competicions",
          "Assegurança de quota",
          "Invitació mensual gratuïta (si pagament anual)",
          "Programa fidelització"
        ]
      },
      bronze: {
        name: "BRONZE",
        price: "600€",
        entry: "300€",
        perRound: "30€ / 24€",
        perRoundLabel: "Greenfee 18/9 forats",
        features: [
          "Targeta Le Club Classic",
          "15% descompte competicions",
          "Descompte lloguer material",
          "Programa fidelització"
        ]
      }
    },
    es: {
      title: "Hazte Abonado",
      subtitle: "Únete a la familia UGOLF ARAVELL",
      intro: "Descubre las ventajas exclusivas de ser abonado en el campo de golf más espectacular de los Pirineos. Tres modalidades adaptadas a tus necesidades.",
      membersAccess: "¿Ya eres abonado?",
      membersBtn: "Acceso Área Miembros",
      quotesTitle: "Modalidades de Abonamiento 2026",
      downloadQuotes: "Descargar cuotas completas (PDF)",
      downloadContract: "Descarregar sol·licitud d'alta (CAT)",
      downloadContractEs: "Descargar solicitud de alta",
      contact: "Contacto",
      contactDesc: "Para más información sobre los abonos",
      whatsapp: "WhatsApp",
      email: "Enviar email",
      entryFee: "Cuota de entrada",
      annual: "Cuota anual",
      perRound: "por vuelta",
      included: "Incluido",
      moreInfo: "Más información",
      oro: {
        name: "ORO",
        price: "2.040€",
        entry: "300€",
        perRound: "5€ / 3€",
        perRoundLabel: "Greenfee 18/9 hoyos",
        features: [
          "Tarjeta Le Club Gold incluida",
          "70% descuento competiciones",
          "Seguro de cuota",
          "Invitación mensual gratuita (si pago anual)",
          "Programa fidelización"
        ]
      },
      plata: {
        name: "PLATA",
        price: "1.400€",
        entry: "300€",
        perRound: "15€ / 12€",
        perRoundLabel: "Greenfee 18/9 hoyos",
        features: [
          "Tarjeta Le Club Gold incluida",
          "50% descuento competiciones",
          "Seguro de cuota",
          "Invitación mensual gratuita (si pago anual)",
          "Programa fidelización"
        ]
      },
      bronze: {
        name: "BRONZE",
        price: "600€",
        entry: "300€",
        perRound: "30€ / 24€",
        perRoundLabel: "Greenfee 18/9 hoyos",
        features: [
          "Tarjeta Le Club Classic",
          "15% descuento competiciones",
          "Descuento alquiler material",
          "Programa fidelización"
        ]
      }
    },
    fr: {
      title: "Devenez Abonné",
      subtitle: "Rejoignez la famille UGOLF ARAVELL",
      intro: "Découvrez les avantages exclusifs d'être abonné au parcours de golf le plus spectaculaire des Pyrénées. Trois formules adaptées à vos besoins.",
      membersAccess: "Déjà abonné?",
      membersBtn: "Accès Espace Membres",
      quotesTitle: "Formules d'Abonnement 2026",
      downloadQuotes: "Télécharger tarifs complets (PDF)",
      downloadContract: "Télécharger demande d'inscription (CAT)",
      downloadContractEs: "Descargar solicitud (ES)",
      contact: "Contact",
      contactDesc: "Pour plus d'informations sur les abonnements",
      whatsapp: "WhatsApp",
      email: "Envoyer email",
      entryFee: "Frais d'inscription",
      annual: "Cotisation annuelle",
      perRound: "par tour",
      included: "Inclus",
      moreInfo: "Plus d'informations",
      oro: {
        name: "OR",
        price: "2.040€",
        entry: "300€",
        perRound: "5€ / 3€",
        perRoundLabel: "Greenfee 18/9 trous",
        features: [
          "Carte Le Club Gold incluse",
          "70% réduction compétitions",
          "Assurance cotisation",
          "Invitation mensuelle gratuite (si paiement annuel)",
          "Programme fidélité"
        ]
      },
      plata: {
        name: "ARGENT",
        price: "1.400€",
        entry: "300€",
        perRound: "15€ / 12€",
        perRoundLabel: "Greenfee 18/9 trous",
        features: [
          "Carte Le Club Gold incluse",
          "50% réduction compétitions",
          "Assurance cotisation",
          "Invitation mensuelle gratuite (si paiement annuel)",
          "Programme fidélité"
        ]
      },
      bronze: {
        name: "BRONZE",
        price: "600€",
        entry: "300€",
        perRound: "30€ / 24€",
        perRoundLabel: "Greenfee 18/9 trous",
        features: [
          "Carte Le Club Classic",
          "15% réduction compétitions",
          "Réduction location matériel",
          "Programme fidélité"
        ]
      }
    },
    en: {
      title: "Become a Member",
      subtitle: "Join the UGOLF ARAVELL family",
      intro: "Discover the exclusive benefits of being a member at the most spectacular golf course in the Pyrenees. Three plans adapted to your needs.",
      membersAccess: "Already a member?",
      membersBtn: "Members Area Access",
      quotesTitle: "Membership Plans 2026",
      downloadQuotes: "Download full rates (PDF)",
      downloadContract: "Download registration form (CAT)",
      downloadContractEs: "Download registration form (ES)",
      contact: "Contact",
      contactDesc: "For more information about memberships",
      whatsapp: "WhatsApp",
      email: "Send email",
      entryFee: "Entry fee",
      annual: "Annual fee",
      perRound: "per round",
      included: "Included",
      moreInfo: "More information",
      oro: {
        name: "GOLD",
        price: "2.040€",
        entry: "300€",
        perRound: "5€ / 3€",
        perRoundLabel: "Greenfee 18/9 holes",
        features: [
          "Le Club Gold card included",
          "70% competition discount",
          "Fee insurance",
          "Free monthly invitation (annual payment)",
          "Loyalty program"
        ]
      },
      plata: {
        name: "SILVER",
        price: "1.400€",
        entry: "300€",
        perRound: "15€ / 12€",
        perRoundLabel: "Greenfee 18/9 holes",
        features: [
          "Le Club Gold card included",
          "50% competition discount",
          "Fee insurance",
          "Free monthly invitation (annual payment)",
          "Loyalty program"
        ]
      },
      bronze: {
        name: "BRONZE",
        price: "600€",
        entry: "300€",
        perRound: "30€ / 24€",
        perRoundLabel: "Greenfee 18/9 holes",
        features: [
          "Le Club Classic card",
          "15% competition discount",
          "Equipment rental discount",
          "Loyalty program"
        ]
      }
    }
  };

  const t = translations[language] || translations.ca;

  const plans = [
    { key: 'oro', icon: Crown, color: 'from-amber-500 to-yellow-600', badge: 'bg-amber-500' },
    { key: 'plata', icon: Star, color: 'from-gray-400 to-gray-500', badge: 'bg-gray-400' },
    { key: 'bronze', icon: Award, color: 'from-amber-700 to-amber-800', badge: 'bg-amber-700' }
  ];

  return (
    <main data-testid="fes-te-abonat-page">
      <SEO title={PAGE_SEO.fesTeAbonat.title} description={PAGE_SEO.fesTeAbonat.description} />
      <SectionHero
        image="https://customer-assets.emergentagent.com/job_6551900b-6eea-49b4-a7ed-baa10c533f6e/artifacts/4mklemif_salonsocial.jpg"
        title={t.title}
        subtitle={t.subtitle}
      />

      {/* Members Access Banner */}
      <section className="bg-[#1A4D2E] py-4">
        <div className="container-custom">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <p className="text-white/90 text-sm">
              <Users className="w-4 h-4 inline mr-2" />
              {t.membersAccess}
            </p>
            <a
              href="https://members.teeone.golf/aravell"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-white text-[#1A4D2E] px-6 py-2 text-xs font-semibold tracking-wide uppercase hover:bg-[#D4AF37] hover:text-white transition-colors"
              data-testid="members-area-btn"
            >
              {t.membersBtn}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* Intro */}
      <section className="section-spacing bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center max-w-3xl mx-auto mb-12"
          >
            <p className="text-[#666666] text-base lg:text-lg leading-relaxed">
              {t.intro}
            </p>
          </motion.div>

          {/* Pricing Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {plans.map((plan, index) => {
              const planData = t[plan.key];
              const Icon = plan.icon;
              return (
                <motion.div
                  key={plan.key}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white border border-[#E5E5E5] hover:border-[#1A4D2E] transition-colors overflow-hidden group"
                  data-testid={`plan-${plan.key}`}
                >
                  {/* Header */}
                  <div className={`bg-gradient-to-r ${plan.color} p-6 text-white`}>
                    <div className="flex items-center justify-between mb-4">
                      <Icon className="w-8 h-8" />
                      <span className={`${plan.badge} text-white text-xs font-bold px-3 py-1 rounded-full`}>
                        {planData.name}
                      </span>
                    </div>
                    <div className="text-3xl font-bold mb-1">{planData.price}</div>
                    <div className="text-white/80 text-sm">{t.annual}</div>
                  </div>

                  {/* Body */}
                  <div className="p-6">
                    {/* Entry fee */}
                    <div className="flex justify-between items-center pb-4 mb-4 border-b border-[#E5E5E5]">
                      <span className="text-sm text-[#666666]">{t.entryFee}</span>
                      <span className="font-semibold text-[#1A4D2E]">{planData.entry}</span>
                    </div>
                    
                    {/* Per round / Greenfee */}
                    <div className="flex justify-between items-center pb-4 mb-4 border-b border-[#E5E5E5]">
                      <span className="text-sm text-[#666666]">{planData.perRoundLabel || t.perRound}</span>
                      <span className="font-semibold text-[#1A4D2E]">{planData.perRound}</span>
                    </div>

                    {/* Features */}
                    <ul className="space-y-3">
                      {planData.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-sm text-[#666666]">
                          <Check className="w-4 h-4 text-[#1A4D2E] flex-shrink-0 mt-0.5" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              );
            })}
          </div>

          {/* Download Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-12 bg-[#F9F9F7] p-6 lg:p-8"
          >
            <h3 className="font-display text-lg font-medium text-[#1A4D2E] mb-6 text-center">
              {t.moreInfo}
            </h3>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="https://customer-assets.emergentagent.com/job_6551900b-6eea-49b4-a7ed-baa10c533f6e/artifacts/2q8es9cn_TARIFES%202026%20UGOLF%20ARAVELL.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#1A4D2E] text-white px-6 py-3 text-xs font-semibold tracking-wide uppercase hover:bg-[#153d24] transition-colors"
                data-testid="download-quotes-btn"
              >
                <Download className="w-4 h-4" />
                {t.downloadQuotes}
              </a>
              <a
                href="https://customer-assets.emergentagent.com/job_6551900b-6eea-49b4-a7ed-baa10c533f6e/artifacts/jj435wqq_Contracte%20Abonat%20Ugolf%20Aravell%202026.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 border border-[#1A4D2E] text-[#1A4D2E] px-6 py-3 text-xs font-semibold tracking-wide uppercase hover:bg-[#1A4D2E] hover:text-white transition-colors"
                data-testid="download-contract-cat-btn"
              >
                <Download className="w-4 h-4" />
                {t.downloadContract}
              </a>
              <a
                href="https://customer-assets.emergentagent.com/job_6551900b-6eea-49b4-a7ed-baa10c533f6e/artifacts/1lgm6n8s_CONTRATO%20DE%20ABONADO%20UGOLF%20ARAVELL%202026%5B11%5D.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 border border-[#1A4D2E] text-[#1A4D2E] px-6 py-3 text-xs font-semibold tracking-wide uppercase hover:bg-[#1A4D2E] hover:text-white transition-colors"
                data-testid="download-contract-es-btn"
              >
                <Download className="w-4 h-4" />
                {t.downloadContractEs}
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-[#1A4D2E]">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-display text-2xl text-white font-medium mb-2">
              {t.contact}
            </h2>
            <p className="text-white/70 mb-8 max-w-md mx-auto">
              {t.contactDesc}
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="https://wa.me/34661194023"
                onClick={() => trackWhatsAppLead('fes-te-abonat')}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-8 py-4 text-xs font-semibold tracking-wide uppercase hover:bg-[#1da851] transition-colors"
                data-testid="whatsapp-btn"
              >
                <Phone className="w-4 h-4" />
                {t.whatsapp}
              </a>
              <a
                href="/contacte"
                className="flex items-center justify-center gap-2 bg-white text-[#1A4D2E] px-8 py-4 text-xs font-semibold tracking-wide uppercase hover:bg-[#D4AF37] hover:text-white transition-colors"
                data-testid="contact-btn"
              >
                <Mail className="w-4 h-4" />
                {t.email}
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default FesTeAbonatPage;
